<template>
  <div>
    <h1 id="jump-to-header">{{heading || "View"}}</h1>
    <b-card bg-variant="light">
      <b-row>
        <b-col md="4">
          <interest-show :id="id" @gotAttrs="assignAttrs"></interest-show>
        </b-col>
        <b-col md="8">
          <!-- <b-tabs
            active-nav-item-class="font-weight-bold text-uppercase text-warning"
            active-tab-class="font-weight-bold text-success"
            content-class="mt-3"
            lazy
          >
            <b-tab title="Product Models" active> -->
              <product-model-index
                :filtering="filtering"
                :ams_template="ams_template"
              ></product-model-index>
            <!-- </b-tab>
          </b-tabs> -->
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import InterestShow from './InterestShow.vue'
import ProductModelIndex from './ProductModelIndex.vue'

export default {
  components: {
    InterestShow,
    ProductModelIndex,
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      filtering: {
        interest_subtree_ids: this.id
      },
      attrs: {},
      ams_template: {
        type: 'product-models',
        description: undefined,
        attributes: {
          'interest-id': this.id
        }
      },
    }
  },
  methods: {
    assignAttrs(attrs) {
      this.attrs = Object.assign( {}, attrs)
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>